import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
//import { NavLink} from "react-router-dom";
import axios from 'axios'
import { connectNode } from '../../../utils/global'
import { escapeHtml } from '../../../utils/textFunctions'
import '../../../styles/assets/css/admin/form1.css'
import { loadLocationWithMessage } from '../../../actions/location'

import WarningIcon from '@material-ui/icons/Warning'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import PatientHead3 from "../patient/patient_head3"

class EditStepCurrent extends Component {
  constructor() {
      super();
      this.state = {
          status: false,
          message: '',
          success_message: '',
          stepList: ['N/A', 1, 2, 3, 4, 5],
          step_current: '',
          backup_step: 0,
          sub_role: 0,
      }
  }

  componentDidMount() {
    this.getPatientStatus()
  }

  getPatientStatus = () => {
    var pid = this.props.match.params.pid
    axios({
      method: 'post',
      url: connectNode + 'admin/patient/get_step_current2',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        pid: pid,
        uid: this.props.authReducer.uid,
        user_role: this.props.authReducer.role,
      }
    })
    .then((result) => {
      if(result['data'].step_current) {
        this.setState({
          step_current: result['data'].step_current,
          backup_step: result['data'].step_current,
          sub_role: result['data'].sub_role,
        })
      } else if(!result['data'].step_current) {
        this.setState({
          sub_role: result['data'].sub_role,
        })
      }

    })
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    //console.log(this.state)
    if(this.state.step_current === '' ) {
      this.setState({
        message: 'Please provide step',
      })
      window.scrollTo(0, 0)
    } else {
      var pid = this.props.match.params.pid
      axios({
        method: 'post',
        url: connectNode + 'admin/patient/edit_step_current',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
        },
        data: {
          uid: this.props.authReducer.uid,
          pid: pid,
          user: this.state,
        }
      })
      .then((result) => {
        console.log(result['data'])
        if(result['data'] === this.props.match.params.pid) {
          this.setState({
            success_message: 'Step successfully updated!',
          })
          window.scrollTo(0, 0)
          this.props.onLoadLocation('/admin/edit_step_current/'+pid, 'Update step successfully!')
          this.props.history.push('/admin/edit_step_current/'+pid)
        }
      })
    }
  }

  render() {
    return (
      <div className="admin_make_appointment box_border4">
        <div className="row">
          <div className="small-12 columns headerPage1">
            Patient Step (Last 30 days)
          </div>
        </div>
        {(this.props.authReducer.role <= 3 || (this.props.authReducer.role == 6 && this.state.sub_role == 2)) && <>
        <div className="row">
          <div className="small-12 columns ">
            <div className="box_border5">
              <form id="make_appointment" onSubmit={this.handleSubmit}>
                <PatientHead3 />
                <div className="row">
                  <div className="small-12 columns box_inner2 top_space1">
                    <div className="row">
                    <div className="small-12 columns">
                    { this.state.message !== '' &&
                    <div className="small-12 columns warning_msg6">
                      <div className="float_left1"><WarningIcon /></div>
                      <div className="txt_warning_msg1">{ this.state.message }</div>
                    </div>}
                    { this.state.success_message !== '' &&
                    <div className="small-12 columns warning_msg7">
                      <div className="float_left1"><WarningIcon /></div>
                      <div className="txt_warning_msg1">{ this.state.success_message }</div>
                    </div>}
                    </div>
                      <div className="small-12 columns top_space1">
                        <div className="small-12 medium-4 columns bold_txt3">Patient Step (Last 30 days): </div>
                        <div className="small-12 medium-5 columns float_left">
                          <FormControl variant="outlined">
                            <Select value={this.state.step_current} variant="outlined" name="step_current"
                              label="" onChange={(e) => this.handleChange(e, 'step_current')}>
                              <MenuItem value=""></MenuItem>
                              {this.state.stepList.map((each, index) =>
                                <MenuItem key={'p'+index} value={each}>{each}</MenuItem>
                              )}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                      <div className="small-12 columns top_space1">
                        <div className="sep_line1">&nbsp;</div>
                        <div className="small-12 columns">
                        Step 5: Short-term individual therapy<br />
                        Step 4: Short-term skills training<br />
                        Step 3: Group<br />
                        Step 2: Independent work with individual skills coaching (e.g., interns, prac students)<br />
                        Step 1: Independent work with PN support<br />
                        Step N/A:
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row top_space1">
                  <div className="small-12 columns text_align_right">
                    <Button variant="contained" color="primary" disableElevation
                     onClick={this.handleSubmit} type="submit">
                      Submit
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div></>}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  //console.log('AddPatient STATE: ', state)
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    //console.log('AddPatient mapDispatchToProps')
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(EditStepCurrent)
